var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"selectTabBox"},_vm._l((_vm.selectTabList),function(item,index){return _c('li',{key:index,class:item === _vm.curSelectTab ? 'actClass' : '',on:{"click":function($event){return _vm.$emit('selectTab', item)}}},[_c('span',[_vm._v(_vm._s(item)+" "),_c('span',{staticClass:"lineBox"})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }